var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.75 9.31763C22.75 5.99224 21.2676 3.50983 18.9609 2.60661C16.8252 1.77035 14.2618 2.39603 12 4.51334C9.73815 2.39603 7.17479 1.77035 5.0391 2.60662C2.73242 3.50984 1.25 5.99226 1.25 9.31767C1.25 11.4356 2.38041 13.5198 3.78729 15.3141C5.20863 17.1269 6.99671 18.7501 8.48914 19.9612L8.62327 20.0701C9.82386 21.0458 10.6906 21.7502 12 21.7502C13.3094 21.7502 14.1762 21.0458 15.3767 20.0702L15.5109 19.9612C17.0033 18.7501 18.7914 17.1269 20.2127 15.3141C21.6196 13.5198 22.75 11.4356 22.75 9.31763Z",
    fill: "#0450DD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 7.00017C17.25 6.58595 16.9142 6.25017 16.5 6.25017C16.0858 6.25017 15.75 6.58595 15.75 7.00017V8.25018H14.5C14.0858 8.25018 13.75 8.58597 13.75 9.00018C13.75 9.4144 14.0858 9.75018 14.5 9.75018H15.75V11.0002C15.75 11.4144 16.0858 11.7502 16.5 11.7502C16.9142 11.7502 17.25 11.4144 17.25 11.0002V9.75018H18.5C18.9142 9.75018 19.25 9.4144 19.25 9.00018C19.25 8.58597 18.9142 8.25018 18.5 8.25018H17.25V7.00017Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartActive);
export default __webpack_public_path__ + "static/media/heart_active.7abad7569e44959f8de3e9c04bb7971e.svg";
export { ForwardRef as ReactComponent };